import { TermsAndConditions } from 'features/terms-dialog/components/terms-and-conditions'

export const TermsPage: React.FC = () => {
  return <TermsAndConditions />
}
